import { useEffect } from "react";

type KeyCombination = {
  keys: string[];
  callback: () => void;
};

export const useKeyboardShortcut = (shortcuts: KeyCombination[]) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      shortcuts.forEach(({ keys, callback }) => {
        const pressedKeys = [
          event.ctrlKey ? "Control" : null,
          event.shiftKey ? "Shift" : null,
          event.altKey ? "Alt" : null,
          event.metaKey ? "Meta" : null,
          event.key,
        ]
          .filter(Boolean)
          .map((key) => key && key.toLowerCase());

        const normalizedKeys = keys.map((key) => key.toLowerCase());
        const isMatch = normalizedKeys.every((key) =>
          pressedKeys.includes(key),
        );

        if (isMatch) {
          event.preventDefault();
          callback();
        }
      });
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [shortcuts]);
};
